import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "col-span-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase" }
const _hoisted_2 = { class: "col-span-1 justify-self-end px-6 py-2 text-sm text-gray-500 w-full" }
const _hoisted_3 = {
  key: 1,
  class: "py-2 whitespace-nowrap text-sm text-gray-500"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "px-14 py-2 whitespace-nowrap text-sm text-gray-500"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open options", -1)
const _hoisted_7 = { class: "py-1" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 0 }

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { EllipsisVerticalIcon, PlayIcon, XCircleIcon } from "@heroicons/vue/24/solid";
import { format } from "date-fns";
import { PropType, ref } from "vue";
import LoadingSpinner from "@/components/UI/LoadingSpinner.vue";
import { useStreams } from "@/composables/stream";
import { CustomizableTimelapse } from "@/types/CustomizableTimelapse";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTimeLapseMobile',
  props: {
  timelapseVideos: {
    type: Array as PropType<CustomizableTimelapse[]>,
  },
},
  emits: ["playVideo", "deleteTimelapseVideo"],
  setup(__props) {




const headers = ref<Array<string>>([
  "name",
  "camera",
  "start_date",
  "end_date",
  "duration",
  "created",
  "play",
  "extended",
]);

const { streams } = useStreams();

const formatDate = (date: Date): string => {
  return format(date, "dd.MM.yyyy");
};
const formatDateWithTime = (date: Date): string => {
  return format(date, "dd.MM.yyyy HH:mm:ss");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.timelapseVideos, (entry) => {
    return (_openBlock(), _createElementBlock("div", {
      key: entry._id,
      class: "divide-y border-b mb-3 lg:hidden border-r border-l"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value, (header) => {
        return (_openBlock(), _createElementBlock("div", {
          key: header,
          class: "grid grid-cols-2 divide-x first:border-t items-center first:font-bold first:capitalize"
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(`camera.customizable_timelapse.table.${header}`)), 1),
          _createElementVNode("div", _hoisted_2, [
            (['start_date', 'end_date'].includes(header))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(formatDate(entry[header as keyof CustomizableTimelapse] as unknown as Date)), 1)
                ], 64))
              : (header === 'created')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(formatDateWithTime(entry[header as keyof CustomizableTimelapse] as unknown as Date)), 1)
                  ], 64))
                : (header === 'camera')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_unref(streams).find((stream) => stream["camera_id"] === entry.camera_id)?.name ||
            entry.camera_id), 1)
                    ], 64))
                  : (header === 'play')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (entry.status === 'generating')
                          ? (_openBlock(), _createBlock(LoadingSpinner, {
                              key: 0,
                              class: "h-4 w-4"
                            }))
                          : (entry.status === 'ready')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.$emit('playVideo', entry.url)),
                                  type: "button",
                                  class: "inline-flex items-center px-4 py-1 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                                }, [
                                  _createVNode(_unref(PlayIcon), {
                                    class: "-ml-1 mr-3 h-5 w-5",
                                    "aria-hidden": "true"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.play_button")), 1)
                                ], 8, _hoisted_4)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_unref(XCircleIcon), {
                                  class: "-ml-1 mr-3 h-6 w-6 text-orange-400",
                                  "aria-hidden": "true"
                                })
                              ]))
                      ], 64))
                    : (header === 'extended')
                      ? (_openBlock(), _createBlock(_unref(Menu), {
                          key: 4,
                          as: "div",
                          class: "relative inline-block text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(MenuButton), { class: "rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-yellow-300" }, {
                              default: _withCtx(() => [
                                _hoisted_6,
                                _createVNode(_unref(EllipsisVerticalIcon), {
                                  class: "h-5 w-5",
                                  "aria-hidden": "true"
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_Transition, {
                              "enter-active-class": "transition ease-out duration-100",
                              "enter-from-class": "transform opacity-0 scale-95",
                              "enter-to-class": "transform opacity-100 scale-100",
                              "leave-active-class": "transition ease-in duration-75",
                              "leave-from-class": "transform opacity-100 scale-100",
                              "leave-to-class": "transform opacity-0 scale-95"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MenuItems), { class: "z-10 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-2 ring-gray/5 focus:outline-none" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_unref(MenuItem), null, {
                                        default: _withCtx(({ active }) => [
                                          _createElementVNode("a", {
                                            href: "#",
                                            onClick: _withModifiers(($event: any) => (_ctx.$emit('deleteTimelapseVideo', entry)), ["prevent"]),
                                            class: _normalizeClass([
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        'block px-4 py-2 text-sm',
                      ])
                                          }, _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.extended_remove")), 11, _hoisted_8)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (entry.url)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createVNode(_unref(MenuItem), null, {
                                              default: _withCtx(({ active }) => [
                                                _createElementVNode("a", {
                                                  href: entry.url,
                                                  class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm',
                        ])
                                                }, _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.extended_download")), 11, _hoisted_10)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createTextVNode(_toDisplayString(entry[header as keyof CustomizableTimelapse]) + " ", 1),
                          (header === 'duration')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.duration_min")), 1))
                            : _createCommentVNode("", true)
                        ], 64))
          ])
        ]))
      }), 128))
    ]))
  }), 128))
}
}

})